export const actionTypes = {
    SET_ACTIVE_COMPONENT: 'set active component',
    START_STOP_PLAYING: 'start stop playing',
    ADD_MESSAGE_TO_CHAT: 'add message to chat',
    REMOVE_QUESTION: 'set question as text',
    RESET_CHAT: 'reset chat',
}
